import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import '../static/Security.css';

import FadeIn from '../components/global/FadeIn';
import securityLogo from '../assets/security/fed-anti-piracy.png';

import { setTargetParams } from '../redux/actions/index';

class Security extends Component {
	constructor(props) {
		super(props);
		
		this.gotoRegister = this.gotoRegister.bind(this);
	}

	componentDidMount() {
		if(!this.props.targetParams) {
			this.props.history.push('/register');
		}

		window.$('body').animate({ scrollTop: 0 }, 0);
	}

	gotoRegister() {
		this.props.history.push('/register');
	}

	render() {
		return (
			<FadeIn>
				<div className={"pilotly-security" + (!this.props.targetParams ? " display-none" : "")}>
					<div className="row ready-to-begin security-container">
						<div className="security-logo-wrapper">
							<img src={securityLogo} alt="Security Logo" />
						</div>
						<p className="security-message">
							<FormattedMessage
								id="security.message"
								defaultMessage={"The unauthorized reproduction or distribution of this copyrighted work is illegal.  All content screened on Pilotly is watermarked for piracy tracking purposes. Criminal copyright infringement, including infringement without monetary gain, is investigated by the FBI and is punishable by up to 5 years in prison and a fine of $250,000."}
							/>
						</p>
						<p className="security-message">
							<FormattedMessage
								id="security.understand"
								defaultMessage={"If you understand the above security measures, please click below"}
							/>
						</p>
						<button className="btn waves-effect waves-light text-capitalize" onClick={this.gotoRegister}>
							<FormattedMessage
								id="security.button.agree"
								defaultMessage={"Agree"}
							/>
						</button>
					</div>
				</div>
			</FadeIn>
		)
	}
}

function mapStateToProps(state) {
	return {
		currentUser: state.currentUser.currentUser,
		fetchedDistributionList: state.targetProcess.fetchedDistributionList,
		fetchedGroup: state.targetProcess.fetchedGroup,
		targetParams: state.targetProcess.targetParams
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setTargetParams
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Security)


// WEBPACK FOOTER //
// ./src/pages/Security.js